import JSONRPC from './JSONRPC';
import type { JSONRPCQtObject, JsonRpcTransport } from './types/JSONRPCAPI';

export type {
  JSONRPCQtObject,
  JsonRpcTransport,
  QtSignal,
} from './types/JSONRPCAPI';

export default class JSONRPCAPI {
  protected jsonrpc: JsonRpcTransport;

  constructor() {
    // dummy dispatcher that resolves all calls to null
    this.jsonrpc = {
      request: <T>() => Promise.resolve(null as T),
      handleResponse: () => undefined,
    };
  }

  connect(qtobject: JSONRPCQtObject): void {
    try {
      this.jsonrpc = new JSONRPC((message) => {
        qtobject.dispatch(JSON.stringify(message));
      });
      qtobject.response.connect((str) =>
        this.jsonrpc.handleResponse(JSON.parse(str))
      );
    } catch (e) {
      console.log('Error in JSONRPC Qt connection');
      console.log(e);
    }
  }
}
